/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { IAbsoluteMediaContainerConfig, IAbsoluteMediaContainerProps } from './absolute-media-container.props.autogenerated';


export interface IAbsoluteMediaContainerViewProps extends IAbsoluteMediaContainerProps<IAbsoluteMediaContainerConfig> {

    row2categories?: React.ReactNode[];
    Row2List: IModuleProps;
    Row2ListItem: INodeProps;
    
    columnHeading2: string;
    
    
   
}


/**
 *
 * AbsoluteMediaContainer component.
 * @extends {React.PureComponent<IAbsoluteMediaContainerProps<IAbsoluteMediaContainerConfig>>}
 */
 class AbsoluteMediaContainer extends React.PureComponent<IAbsoluteMediaContainerProps<IAbsoluteMediaContainerConfig>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const ColumnHeading2 = config.columnHeading2 ? config.columnHeading2 : '';
        

        
        if (!this.props.slots || !this.props.slots.row2 || this.props.slots.row2.length === 0) {
            this.props.context.telemetry.error('row2 is empty, module wont render');
            return null;
        }
       


        const viewprops = {
            ...this.props,

            columnHeading2: ColumnHeading2,
            
            
            
            row2categories: this.props.slots.row2,
            Row2List: {
                moduleProps: this.props,
                className: classnames('ff-row', this.props.config.className),
                tag: 'div'
            },
            Row2ListItem: {
                className: classnames('ff-row-column', this.props.config.className),
                tag: 'div'
            },
            
            
        };

        return this.props.renderView(viewprops) as React.ReactElement;
        
    }
}

export default AbsoluteMediaContainer;
